export const environment = {
  actioncable_url: null,
  production: true,
  test: false,
  url: 'https://v7.attymatter.com',
  console_logging: true
};
